
import { NetworkPartnership } from '@/utils/whitelabels';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CPNetworkPartnership extends Vue {
  @Prop({ default: null })
  public partnership!: NetworkPartnership | null;
}
